import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const Linkedin = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (!document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) {
      const script = document.createElement("script");
      script.src = "https://elfsightcdn.com/platform.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const widgetClass =
    i18n.language === "en"
      ? "elfsight-app-5000f850-b265-4156-8afb-1610cabde2b8"
      : "elfsight-app-3edf1242-cd9c-4f43-b057-bc187c981ea2";

  return (
    <section style={{ overflow: "hidden", minHeight: "500px" }}>
      <div className="text-center marginBottom paddingTop">
        <h3 className="titre text-md-start text-center ps-2">{t("nouvelles")}</h3>

        <div key={i18n.language} className={widgetClass} data-elfsight-app-lazy></div>
      </div>
    </section>
  );
};

export default Linkedin;